import { Locator } from "../locator";

export class Distributors {
	public constructor() {
		const locatorElement = document.querySelector(".locator-widget") as HTMLElement;
		if (locatorElement) {
			new Locator(locatorElement);
		}

	}
}